import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import arrayMove from "array-move";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import alpha from "Assets/Svg/alpha-numeric.svg";
import dton from "Assets/Svg/date.svg";
import drag from "Assets/Svg/drag.svg";
import dropdown from "Assets/Svg/dropdown-selection.svg";
import checkboxIcon from "Assets/Svg/list-checkbox.svg";
import num from "Assets/Svg/numerical.svg";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { ErrorMessages } from "Constants";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { bindActionCreators } from "redux";

const questioncategories = [
  {
    displayname: "Company and culture questions",
    displayvalue: 1,
  },
  {
    displayname: "New question",
    displayvalue: 2,
  },
];

const SortableItem = SortableElement(
  ({
    value1,
    onMoreOptionsClick,
    expanded,
    index,
    AddQuestion1,
    idx,
    mulitiselectoption,
    option,
    handleExpandClick,
    questionOptions,
    handleChange1,
    setInputType1,
    removeOption1,
    addOption1,
    addMultiOption,
    onEdit,
    onDelete,
    closeexpansion,
    state,
  }) => (
    <ExpansionPanel
      expanded={expanded}
      // {expanded == true ?  onChange={() =>
      //   handleExpandClick(expanded)
      // } : " "}

      className="rounded-rectangle-paper margin-bottom-16"
    >
      <ExpansionPanelSummary>
        {/* <Paper
          className="rounded-rectangle-paper margin-bottom-16 width100"
          style={{ padding: "8px 32px" }}
        > */}
        <Grid container>
          <Grid item md={11} sm={12}>
            <img
              src={drag}
              className="vertical-middle floatleft margin-right-16"
            ></img>
            <div className="floatleft">
              <p className="small-dark-secondary t-bold padding-top-8">
                {value1 && value1.question
                  ? value1.question && value1.question.questiontext
                  : value1 && value1.questiontext}
              </p>
            </div>
          </Grid>
          <Grid
            item
            md={1}
            sm={12}
            className="display-flex"
            style={{ justifyContent: "flex-end", alignItems: "center" }}
          >
            {/* {idx != state.index && (
              <div
                className="floatright padding-top-10"
                onClick={(e, row, idx1) => onMoreOptionsClick(e, row, idx1)}
              >
                <img src={kebabIcon}></img>
              </div>
            )} */}

            {idx != state.index && (
              <img
                src={editIcon}
                // onClick={() => onEdit(state.index)}
                onClick={(e, row, idx1) => onEdit(e, row, idx1)}
                style={{ marginRight: 16 }}
                height="16"
              ></img>
            )}
            <img
              src={deleteIcon}
              onClick={(e, row, idx1) => onDelete(e, row, idx1)}
              height="16"
            ></img>
          </Grid>
        </Grid>
        {/* </Paper> */}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {expanded == true && idx == state.index ? (
          <div>
            <DynamicForm
              className="width50"
              fields={textareainputconverter({
                value:
                  (value1 && value1.question && value1.question.questiontext) ||
                  value1.questiontext ||
                  null,
                placeholder: "Enter question",
                label: "Question",
              })}
              onChange={(value) => {
                handleChange1("questiontext", value, idx);
              }}
            />
            <p className="small-dark-secondary margin-bottom-8">Answer type</p>
            <div className="margin-bottom-8">
              <Tooltip title="Text" placement="top-start">
                <img
                  src={alpha}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      (value1 &&
                        value1.question &&
                        value1.question.inputvaluetypeid == 1) ||
                      null
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => setInputType1(1, idx)}
                ></img>
              </Tooltip>
              <Tooltip title="Numeric" placement="top-start">
                <img
                  src={num}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      (value1 &&
                        value1.question &&
                        value1.question.inputvaluetypeid == 2) ||
                      null
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => setInputType1(2, idx)}
                ></img>
              </Tooltip>
              <Tooltip title="Date" placement="top-start">
                <img
                  src={dton}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      (value1 &&
                        value1.question &&
                        value1.question.inputvaluetypeid == 3) ||
                      null
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => setInputType1(3, idx)}
                ></img>
              </Tooltip>
              <Tooltip title="Multi-choice" placement="top-start">
                <img
                  src={dropdown}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      (value1 &&
                        value1.question &&
                        value1.question.inputvaluetypeid &&
                        value1.question.inputvaluetypeid == 4) ||
                      null
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => setInputType1(4, idx)}
                ></img>
              </Tooltip>
              <Tooltip title="Multi-select" placement="top-start">
                <img
                  src={checkboxIcon}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      (value1 &&
                        value1.question &&
                        value1.question.inputvaluetypeid &&
                        value1.question.inputvaluetypeid == 5) ||
                      null
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => setInputType1(5, idx)}
                ></img>
              </Tooltip>
            </div>
            {option &&
              value1 &&
              value1.question &&
              value1.question.inputvaluetypeid &&
              value1.question.inputvaluetypeid == 4 &&
              value1 &&
              value1.question &&
              value1.question.questioninputoption &&
              value1.question.questioninputoption.map((x, i) => (
                <Grid container className="margin-top-8" spacing={2}>
                  <Grid item md={11} sm={12}>
                    <DynamicForm
                      fields={textinputconverter({
                        value: x.optionname,
                        placeholder: "Enter option",
                        label: `Option ${i + 1}`,
                      })}
                      onChange={(value) => {
                        handleChange1("optionname", value, idx, i);
                      }}
                    />
                  </Grid>
                  <Grid item md={1} sm={12}>
                    <img
                      src={deleteIcon}
                      style={{
                        display: "table",
                        marginRight: 8,
                        marginTop: 26,
                        cursor: "pointer",
                      }}
                      onClick={() => removeOption1(idx, i)}
                    ></img>
                  </Grid>
                </Grid>
              ))}
            {value1 &&
              value1.question &&
              value1.question.inputvaluetypeid &&
              value1.question.inputvaluetypeid == 4 && (
                <Button
                  className="btn btn-secondary-md-blue width100"
                  onClick={() => addOption1(idx)}
                >
                  Add option
                </Button>
              )}
            {option &&
              value1 &&
              value1.question &&
              value1.question.inputvaluetypeid &&
              value1.question.inputvaluetypeid == 5 &&
              value1.question.questioninputoption &&
              value1.question.questioninputoption.map((x, i) => (
                <Grid container className="margin-top-8" spacing={2}>
                  <Grid item md={11} sm={12}>
                    <DynamicForm
                      fields={textinputconverter({
                        value: x.optionname,
                        placeholder: "Enter item",
                        label: `Item ${i + 1}`,
                      })}
                      onChange={(value) => {
                        handleChange1("optionname", value, idx, i);
                        // this.handleChange1(value, "optionname", idx, i);
                      }}
                    />
                  </Grid>
                  <Grid item md={1} sm={12}>
                    <img
                      src={deleteIcon}
                      style={{
                        display: "table",
                        marginRight: 8,
                        marginTop: 26,
                        cursor: "pointer",
                      }}
                      onClick={() => removeOption1(idx, i)}
                    ></img>
                  </Grid>
                </Grid>
              ))}
            {value1 &&
              value1.question &&
              value1.question.inputvaluetypeid &&
              value1.question.inputvaluetypeid == 5 && (
                <Button
                  className="btn btn-secondary-md-blue width100"
                  onClick={() => addOption1()}
                >
                  Add item
                </Button>
              )}
            {/* <div style={{ width: 400, marginTop: 16 }}>
              <DynamicForm
                fields={checkboxinputconverter({
                  value: value1.question && value1.question.istemplate,
                  placeholder: "",
                  label: "Save in Company & Culture questions",
                })}
                onChange={(value) => {
                  handleChange1("istemplate", value, idx);
                }}
              />
            </div> */}
            {/* {questionOptions && ( */}
            <Button
              color="primary"
              variant="contained"
              type="button"
              className="btn btn-secondary-md-blue margin-top-8"
              onClick={AddQuestion1}
              // disabled={this.props.SaveInProgressReducer.issaveinprogress}
            >
              Save
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="button"
              className="btn btn-trans margin-top-8 margin-left-8"
              onClick={closeexpansion}
              // onClick={() => this.setState({ expanded: false, selectedRow: null, })}
            >
              Cancel
            </Button>
            {/* )} */}
          </div>
        ) : (
          ""
        )}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  ),
);

const SortableList = SortableContainer(
  ({
    items,
    onMoreOptionsClick,
    expanded,
    handleExpandClick,
    handleChange1,
    setInputType1,
    removeOption1,
    addOption1,
    addMultiOption,
    mulitiselectoption,
    option,
    state,
    AddQuestion1,
    onEdit,
    onDelete,
    closeexpansion,
  }) => (
    <div>
      {items &&
        items.map((value1, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            idx={index}
            value1={value1}
            expanded={expanded}
            option={option}
            mulitiselectoption={mulitiselectoption}
            onMoreOptionsClick={(i) => onMoreOptionsClick(i, value1, index)}
            onEdit={(i) => onEdit(i, value1, index)}
            onDelete={(i) => onDelete(i, value1, index)}
            handleExpandClick={handleExpandClick}
            handleChange1={(key, value2, index1, i) =>
              handleChange1(key, value2, index1, i)
            }
            setInputType1={(key1, index1) => setInputType1(key1, index1)}
            removeOption1={(i, idx1) => removeOption1(i, idx1)}
            addOption1={(index1) => addOption1(index1)}
            addMultiOption={addMultiOption}
            closeexpansion={closeexpansion}
            state={state}
            AddQuestion1={AddQuestion1}
          />
        ))}
    </div>
  ),
);

class ScreeningQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: null,
      isedit: true,
      selectedRow: null,
      companyquestionid: null,
      SelectedEmpData: null,
      tempData: null,
      expanded: false,
      anchorEl: null,
      postData: {
        ...this.props.postData,
        jobtemplatequestions: this.props.postData.jobtemplatequestions
          ? this.props.postData.jobtemplatequestions
          : [],
      },
      moreoptions: false,
      moreoptions_anchorEl: null,
      idx: "",
      questionOptions: null,
      jobtemplatequestions: {
        jobtemplatequestionid: null,
        questionid: null,
        questionorder: null,
        question: {
          questioncategoryid: 1,
          questiontext: " ",
          inputvaluetypeid: null,
          istemplate: false,
          questioninputoption: [],
        },
      },

      // postData: [{ fields: [{ option: [] }] }],
      option: [],
      companyquestions: [],
    };
    this.setInputType = this.setInputType.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onMoreOptionsClick = this.onMoreOptionsClick.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.addOption = this.addOption.bind(this);
    this.addOption1 = this.addOption1.bind(this);
    this.addMultiOption = this.addMultiOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.removeOption1 = this.removeOption1.bind(this);
    this.AddQuestion = this.AddQuestion.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.AddQuestion1 = this.AddQuestion1.bind(this);
    this.setInputType1 = this.setInputType1.bind(this);
    this.closeexpansion = this.closeexpansion.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      onSaveDraft: this.state.postData.jobtemplateid ? "" : this.onSaveDraft,
    });
    this.getCompanyQuestions();
  }

  async getCompanyQuestions() {
    try {
      const allcompanyquestions = await instance.post(
        `recruit/getallquestionbycategory`,
        {
          questioncategoryid: 1,
          isactive: null,
          istemplate: true,
          offset: 0,
          limit: 10,
        },
      );
      await this.setState({
        companyquestions: allcompanyquestions.data.result,
      });
    } catch (e) {}
  }

  handleExpandClick(expanded) {
    this.setState({
      // (state) => ({
      expanded: !expanded,
    });
  }

  // onEdit(item) {
  //   console.log("hello");
  //   this.setState({
  //     tempData: item,
  //     sourcetypename: item.sourcetypename,
  //     expanded: true,
  //   });
  //   console.log("expanded:", this.state.expanded);
  // }
  onMoreOptionsClick(event, row, index) {
    this.setState({
      moreoptions: !this.state.moreoptions,
      moreoptions_anchorEl: event.currentTarget,
      selectedRow: row,
      index,
    });
  }

  onEdit(event, row, index) {
    const { postData, expanded } = this.state;

    const selectedRow = row;

    if (selectedRow.questionid && this.state.isedit == true) {
      instance
        .get(`/recruit/getquestionbyid/${selectedRow.questionid}`)
        .then((resp) => {
          const index =
            postData.jobtemplatequestions &&
            postData.jobtemplatequestions.findIndex(
              (x) => x.questionid == selectedRow.questionid,
            );
          if (postData.jobtemplatequestions)
            postData.jobtemplatequestions[index].question = resp.data.result[0];
          this.setState({
            postData,
            index,
            expanded: true,
            moreoptions: false,
          });
        });
    } else {
      this.setState({
        expanded: true,
        index,
        moreoptions: false,
      });
    }
  }

  closeexpansion() {
    this.setState({ expanded: false, selectedRow: null, index: null });
  }

  onDelete(event, row, index) {
    const { postData } = this.state;
    const selectedRow = row;
    if (!index) {
      index = postData.jobtemplatequestions.findIndex(
        (x) => x.questionid == selectedRow.questionid,
      );
    }
    postData.jobtemplatequestions.splice(index, 1);
    this.setState({
      postData,
      moreoptions: false,
    });
  }

  // onMoreOptionsClick(event, row, index) {
  //   this.setState({
  //     moreoptions: !this.state.moreoptions,
  //     moreoptions_anchorEl: event.currentTarget,
  //     selectedRow: row,
  //     index,
  //   });
  // }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { postData } = this.state;
    if (postData && postData.jobtemplatequestions) {
      console.log(postData.jobtemplatequestions.question);
      const f = arrayMove(postData.jobtemplatequestions, oldIndex, newIndex);
      console.log(f);
      postData.jobtemplatequestions = f;
      this.setState({
        postData,
      });
    }
  };

  setInputType(inputvaluetypeid) {
    const { jobtemplatequestions } = this.state;
    jobtemplatequestions.question.inputvaluetypeid = inputvaluetypeid;
    this.setState({
      jobtemplatequestions,
    });
  }

  setInputType1(inputvaluetypeid, index) {
    const { postData } = this.state;
    // if (postData.jobtemplatequestions[index].questionid != null) {
    //   postData.jobtemplatequestions[
    //     index
    //   ].inputvaluetypeid = inputvaluetypeid;
    //   this.setState({
    //     postData,
    //   });
    // } else {
    postData.jobtemplatequestions[index].question.inputvaluetypeid =
      inputvaluetypeid;
    this.setState({
      postData,
    });
    // }
  }

  onSaveDraft() {
    const { postData } = this.state;

    postData.jobtemplatequestions.forEach(
      (x, index) => (x.questionorder = index + 1),
    );
    postData.isdraft = true;
    instance
      .post("recruit/configjobtemplate", postData)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.props.history.push(`${this.props.match.path}/list`);
        this.props.getAllJobTemplate();
        this.setState({
          postData: {
            jobtemplateid: null,
            designationid: null,
            minworkexperience: null,
            maxworkexperience: null,
            budgettypeid: null,
            currencycode: null,
            minbudget: null,
            maxbudget: null,
            gradeid: null,
            noticeperiod: null,
            note: null,
            isactive: true,
            isdraft: true,
            jobtemplatequestions: [],
          },
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  AddQuestion() {
    const { postData, jobtemplatequestions, questionOptions } = this.state;

    if (
      jobtemplatequestions &&
      (jobtemplatequestions.questionid || jobtemplatequestions.question)
    ) {
      if (
        questionOptions == 2 &&
        jobtemplatequestions.question.questiontext == " "
      ) {
        this.props.enqueueSnackbar("Please enter question name", {
          variant: "error",
        });
      } else if (
        questionOptions == 2 &&
        jobtemplatequestions.question.inputvaluetypeid == null
      ) {
        this.props.enqueueSnackbar("Please select input type", {
          variant: "error",
        });
      } else if (
        questionOptions == 2 &&
        (jobtemplatequestions.question.inputvaluetypeid == 4 ||
          jobtemplatequestions.question.inputvaluetypeid == 5) &&
        jobtemplatequestions.question.questioninputoption.optionname == ""
      ) {
        this.props.enqueueSnackbar("Please enter option name", {
          variant: "error",
        });
      } else if (questionOptions == 1 && !jobtemplatequestions.questionid) {
        this.props.enqueueSnackbar("Please select question", {
          variant: "error",
        });
      } else {
        if (
          jobtemplatequestions.question &&
          jobtemplatequestions.question.questioninputoption &&
          jobtemplatequestions.question.questioninputoption.length > 0
        ) {
          jobtemplatequestions.question.questioninputoption.map(
            (item, index) => {
              item.optionorder = index + 1;
              return item;
            },
          );
        }

        postData.jobtemplatequestions.push(jobtemplatequestions);

        this.setState({
          questionOptions: null,
          postData,
          jobtemplatequestions: {
            jobtemplatequestionid: null,
            questionid: null,
            questionorder: null,
            question: {
              questioncategoryid: 1,
              questiontext: " ",
              inputvaluetypeid: null,
              questioninputoption: [],
            },
          },
        });
      }
    }
  }

  AddQuestion1() {
    const { postData } = this.state;
    // postData.jobtemplatequestions.push(jobtemplatequestions);

    this.setState({
      postData,
      expanded: false,
      isedit: false,
      index: null,
    });
  }

  addOption() {
    const { jobtemplatequestions } = this.state;
    jobtemplatequestions.question.questioninputoption.push({
      questioninputoptionid: null,
      optionname: "",
      optionorder: null,
    });
    this.setState({
      jobtemplatequestions,
    });
  }

  addOption1(index) {
    const { postData } = this.state;
    if (postData.jobtemplatequestions[index].questionid != null) {
      postData.jobtemplatequestions[index].questioninputoption.push({
        questioninputoptionid: null,
        optionname: "",
        optionorder: null,
      });
    } else {
      postData.jobtemplatequestions[index].question.questioninputoption.push({
        questioninputoptionid: null,
        optionname: "",
        optionorder: null,
      });
    }
    this.setState({
      postData,
    });
  }

  addMultiOption() {
    const mulitiselectoption = [];
    mulitiselectoption.push({
      mulitiselectoptionname: null,
    });
    this.setState({
      mulitiselectoption,
    });
  }

  removeOption(index) {
    const { jobtemplatequestions } = this.state;
    if (
      jobtemplatequestions.question.questioninputoption &&
      jobtemplatequestions.question.questioninputoption.length > 0
    ) {
      jobtemplatequestions.question.questioninputoption.splice(index, 1);
      this.setState({
        jobtemplatequestions,
      });
    }
  }

  removeOption1(i, index) {
    const { postData } = this.state;
    if (postData.jobtemplatequestions[i].question.questioninputoption) {
      postData.jobtemplatequestions[i].question.questioninputoption.splice(
        index,
        1,
      );
      // postData.jobtemplatequestions.question.questioninputoption[index].optionorder = index + 1;
      this.setState({
        postData,
      });
    }
  }

  UpdateSelectedEmpId(selectedItem) {
    const { jobtemplatequestions } = this.state;
    jobtemplatequestions.questionid = selectedItem
      ? selectedItem.questionid
      : null;
    jobtemplatequestions.questiontext = selectedItem
      ? selectedItem.questiontext
      : null;
    delete jobtemplatequestions.question;
    this.setState({
      companyquestionid: selectedItem ? selectedItem.questionid : null,
      SelectedEmpData: selectedItem,
      jobtemplatequestions,
    });
  }

  handleChange(key, value, index = null) {
    // console.log('handleChange: ', "handleChange");

    const { jobtemplatequestions, postData } = this.state;
    if (index != null) {
      jobtemplatequestions.question.questioninputoption[index][key] = value;
      jobtemplatequestions.question.questioninputoption[index].optionorder =
        index + 1;
    } else if (key == "questiontext") {
      jobtemplatequestions.question[key] = value;
    } else if (key == "questionOptions") {
      const jobtemplatequestions = {
        jobtemplatequestionid: null,
        questionid: null,
        questionorder: null,
        question: {
          questioncategoryid: 1,
          questiontext: " ",
          istemplate: false,
          inputvaluetypeid: null,
          questioninputoption: [],
        },
      };
      this.setState({ [key]: value, jobtemplatequestions });
    } else {
      jobtemplatequestions[key] = value;
      // postData.jobtemplatequestions = jobtemplatequestions
    }
    this.setState({ postData });
  }

  handleChange1(key, value, index, i = null) {
    // console.log('handleChange: ', "handleChange");

    const { postData } = this.state;
    if (i != null) {
      // if (postData.jobtemplatequestions[index].questionid != null) {
      //   postData.jobtemplatequestions[index].questioninputoption[i][
      //     key
      //   ] = value;
      //   postData.jobtemplatequestions[index].questioninputoption[i].optionorder = i + 1;
      // } else {
      postData.jobtemplatequestions[index].question.questioninputoption[i][
        key
      ] = value;
      postData.jobtemplatequestions[index].question.questioninputoption[
        i
      ].optionorder = i + 1;
      // }
    } else {
      // if (postData.jobtemplatequestions[index].questionid != null) {
      //   postData.jobtemplatequestions[index][key] = value;
      // } else {
      postData.jobtemplatequestions[index].question[key] = value;
      // }
    }
    this.setState({ postData });
  }

  onSubmit = () => {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const { postData, jobtemplatequestions, questionOptions } = this.state;
    let valid = false;
    const index =
      postData.jobtemplatequestions &&
      postData.jobtemplatequestions.findIndex(
        (x) => x.question && !x.question.questiontext,
      );

    if (index == -1) {
      valid = true;
    }

    if (
      postData.jobtemplatequestions &&
      postData.jobtemplatequestions.length < 1
    ) {
      this.props.enqueueSnackbar("please enter question", {
        variant: "error",
      });
    } else if (!valid) {
      this.props.enqueueSnackbar("please enter question text", {
        variant: "error",
      });
    } else {
      postData.jobtemplatequestions.forEach((x, index) => {
        if (x.question) {
          x.question.questioninputoption &&
            x.question.questioninputoption.forEach((y) => {
              delete y.questionid;
              return y;
            });
        }
        x.questionorder = index + 1;
        delete x.questiontext;
        delete x.index;
      });
      postData.isdraft = false;
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
          .post("recruit/configjobtemplate", postData)
          .then(() => {
            this.props.enqueueSnackbar(ErrorMessages.E0000, {
              variant: "success",
            });
            this.props.removeSaveProgress();
            this.props.history.push(`${this.props.match.path}/list`);
            this.props.getAllJobTemplate(true);

            this.setState(
              {
                postData: {
                  jobtemplateid: null,
                  designationid: null,
                  minworkexperience: null,
                  maxworkexperience: null,
                  budgettypeid: null,
                  currencycode: null,
                  minbudget: null,
                  maxbudget: null,
                  gradeid: null,
                  noticeperiod: null,
                  note: null,
                  isactive: true,
                  isdraft: false,
                  jobtemplatequestions: [],
                },
              },
              // () => {
              //   this.props.history.push(`${this.props.match.path}/list`);
              //   this.props.getAllJobTemplate(true);
              // },
            );
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  };

  render() {
    const { jobtemplatequestions, questionOptions } = this.state;
    return (
      <div>
        <Paper
          className="rounded-rectangle-paper margin-bottom-16"
          style={{ padding: "16px 32px", border: "1px solid #1E8CED" }}
        >
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <DynamicForm
                fields={selectinputconverter({
                  value: questionOptions,
                  placeholder: "Select question category",
                  label: "Question category",
                  options: questioncategories,
                })}
                onChange={(selectedid) => {
                  this.handleChange("questionOptions", selectedid);
                }}
              />
              {questionOptions == 1 && (
                // <DynamicForm
                //   fields={selectinputconverter({
                //     value: this.state.companyquestionid,
                //     placeholder: "",
                //     label: "Select question",
                //     options: this.state.companyquestions,
                //   })}
                //   onChange={(selectedid) => {
                //     this.handleChange("companyquestionid", selectedid);
                //   }}
                // />
                <div>
                  <p className="input-label">Select question</p>

                  <Select
                    className="selectsearch"
                    onChange={this.UpdateSelectedEmpId.bind(this)}
                    options={this.state.companyquestions}
                    getOptionLabel={(option) => option.questiontext}
                    getOptionValue={(option) => option.questionid}
                    value={this.state.SelectedEmpData}
                    placeholder="Select question"
                  />
                </div>
              )}
              {questionOptions == 2 && (
                <div>
                  <DynamicForm
                    className="width50"
                    fields={textareainputconverter({
                      value:
                        jobtemplatequestions.question &&
                        jobtemplatequestions.question.questiontext,
                      placeholder: "Enter question",
                      label: "Question",
                    })}
                    onChange={(value) => {
                      this.handleChange("questiontext", value);
                    }}
                  />
                  <p className="small-dark-secondary margin-bottom-8">
                    Answer type
                  </p>
                  <div className="margin-bottom-8">
                    <Tooltip title="Text" placement="top-start">
                      <img
                        src={alpha}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            jobtemplatequestions.question &&
                            jobtemplatequestions.question.inputvaluetypeid &&
                            jobtemplatequestions.question.inputvaluetypeid == 1
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(1)}
                      ></img>
                    </Tooltip>
                    <Tooltip title="Numeric" placement="top-start">
                      <img
                        src={num}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            jobtemplatequestions.question &&
                            jobtemplatequestions.question.inputvaluetypeid &&
                            jobtemplatequestions.question.inputvaluetypeid == 2
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(2)}
                      ></img>
                    </Tooltip>
                    <Tooltip title="Date" placement="top-start">
                      <img
                        src={dton}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            jobtemplatequestions.question &&
                            jobtemplatequestions.question.inputvaluetypeid &&
                            jobtemplatequestions.question.inputvaluetypeid == 3
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(3)}
                      ></img>
                    </Tooltip>
                    <Tooltip title="Multi-choice" placement="top-start">
                      <img
                        src={dropdown}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            jobtemplatequestions.question &&
                            jobtemplatequestions.question.inputvaluetypeid &&
                            jobtemplatequestions.question.inputvaluetypeid == 4
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(4)}
                      ></img>
                    </Tooltip>
                    <Tooltip title="Multi-select" placement="top-start">
                      <img
                        src={checkboxIcon}
                        style={{
                          marginRight: 16,
                          cursor: "pointer",
                          border:
                            jobtemplatequestions.question &&
                            jobtemplatequestions.question.inputvaluetypeid &&
                            jobtemplatequestions.question.inputvaluetypeid == 5
                              ? "2px solid #1e8ced"
                              : "2px solid transparent",
                          borderRadius: 20,
                        }}
                        onClick={() => this.setInputType(5)}
                      ></img>
                    </Tooltip>
                  </div>
                  {this.state.option &&
                    jobtemplatequestions.question &&
                    jobtemplatequestions.question.inputvaluetypeid &&
                    jobtemplatequestions.question.inputvaluetypeid == 4 &&
                    this.state.jobtemplatequestions &&
                    this.state.jobtemplatequestions.question &&
                    this.state.jobtemplatequestions.question
                      .questioninputoption &&
                    this.state.jobtemplatequestions.question.questioninputoption.map(
                      (x, i) => (
                        <Grid container className="margin-top-8" spacing={2}>
                          <Grid item md={11} sm={12}>
                            <DynamicForm
                              fields={textinputconverter({
                                value: x.optionname,
                                placeholder: "Enter option",
                                label: `Option ${i + 1}`,
                              })}
                              onChange={(e) => {
                                this.handleChange("optionname", e, i);
                              }}
                            />
                          </Grid>
                          <Grid item md={1} sm={12}>
                            <img
                              src={deleteIcon}
                              style={{
                                display: "table",
                                marginRight: 8,
                                marginTop: 26,
                                cursor: "pointer",
                              }}
                              onClick={() => this.removeOption(i)}
                            ></img>
                          </Grid>
                        </Grid>
                      ),
                    )}
                  {jobtemplatequestions.question &&
                    jobtemplatequestions.question.inputvaluetypeid &&
                    jobtemplatequestions.question.inputvaluetypeid == 4 && (
                      <Button
                        className="btn btn-secondary-md-blue width100"
                        onClick={() => this.addOption()}
                      >
                        Add option
                      </Button>
                    )}
                  {this.state.option &&
                    jobtemplatequestions.question &&
                    jobtemplatequestions.question.inputvaluetypeid &&
                    jobtemplatequestions.question.inputvaluetypeid == 5 &&
                    this.state.jobtemplatequestions.question.questioninputoption.map(
                      (x, i) => (
                        <Grid container className="margin-top-8" spacing={2}>
                          <Grid item md={11} sm={12}>
                            <DynamicForm
                              fields={textinputconverter({
                                value: x.optionname,
                                placeholder: "Enter item",
                                label: `item ${i + 1}`,
                              })}
                              onChange={(e) => {
                                this.handleChange("optionname", e, i);
                              }}
                            />
                          </Grid>
                          <Grid item md={1} sm={12}>
                            <img
                              src={deleteIcon}
                              style={{
                                display: "table",
                                marginRight: 8,
                                marginTop: 26,
                                cursor: "pointer",
                              }}
                              onClick={() => this.removeOption(i)}
                            ></img>
                          </Grid>
                        </Grid>
                      ),
                    )}
                  {jobtemplatequestions.question &&
                    jobtemplatequestions.question.inputvaluetypeid &&
                    jobtemplatequestions.question.inputvaluetypeid == 5 && (
                      <Button
                        className="btn btn-secondary-md-blue width100"
                        onClick={() => this.addOption()}
                      >
                        Add item
                      </Button>
                    )}
                  <div style={{ width: 400, marginTop: 16 }}>
                    <DynamicForm
                      fields={checkboxinputconverter({
                        // value: saveincompany,
                        placeholder: "",
                        label: "Save in Company & Culture questions",
                      })}
                      // onChange={(e) => {
                      //   this.handleChange(e, "saveincompany", idx);
                      // }}
                    />
                  </div>
                </div>
              )}
              {questionOptions && (
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className="btn btn-secondary-md-blue margin-top-16"
                  onClick={this.AddQuestion}
                >
                  Add question
                </Button>
              )}
            </Grid>
          </Grid>
        </Paper>
        <div className="dashed-divider1"></div>
        <SortableList
          distance={1}
          items={
            this.state.postData && this.state.postData.jobtemplatequestions
          }
          onSortEnd={this.onSortEnd}
          expanded={this.state.expanded}
          mulitiselectoption={this.state.mulitiselectoption}
          option={this.state.option}
          onMoreOptionsClick={(i, row, index) =>
            this.onMoreOptionsClick(i, row, index)
          }
          onEdit={(i, row, index) => this.onEdit(i, row, index)}
          onDelete={(i, row, index) => this.onDelete(i, row, index)}
          handleExpandClick={() => this.handleExpandClick()}
          handleChange1={(key, value2, index, i) =>
            this.handleChange1(key, value2, index, i)
          }
          setInputType1={(key1, index1) => this.setInputType1(key1, index1)}
          removeOption1={(i, idx1) => this.removeOption1(i, idx1)}
          addOption1={(index1) => this.addOption1(index1)}
          addMultiOption={() => this.addMultiOption()}
          state={this.state}
          closeexpansion={() => this.closeexpansion()}
          AddQuestion1={() => this.AddQuestion1()}
          // onEdit={() => this.onEdit()}
        />
        {/* <Popover
          open={this.state.moreoptions}
          anchorEl={this.state.moreoptions_anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => this.setState({ moreoptions: false })}
          className="margin-top-8"
        >
          <Paper style={{ width: 190 }}>
            <div>
              <MenuListComponent>
                <ListItem
                  className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                  onClick={() => this.onEdit(this.state.index)}
                  // onClick={this.onEdit}
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Edit1</span>
                  </ListItemText>
                </ListItem>
                <ListItem
                  className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                  // onClick={this.onDelete}
                  onClick={(i) => this.onDelete(i)}
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Delete</span>
                  </ListItemText>
                </ListItem>
              </MenuListComponent>
            </div>
          </Paper>
        </Popover>
      */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(ScreeningQuestions));
